import styled from 'styled-components';
import * as GStyled from '../../../../styles/components';

const DeleteButtonCell = styled(GStyled.FlatButton)`
  display: inline-block;
`;

export { DeleteButtonCell };
